import React, { Component } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    TextField,
    Grid,
    Chip,
    Button,
    Stepper,
    Step,
    StepLabel,
    StepConnector,
    stepConnectorClasses,
    styled,
    InputAdornment,
    CircularProgress
} from '@mui/material';
import {
    Storefront as StoreIcon,
    LocalShipping as ShippingIcon,
    LocalMall as MallIcon,
    AutoAwesome as SparklesIcon,
    Memory as ChipIcon,
    HomeOutlined as HomeIcon,
    ChildCare as BabyIcon,
    MoreHoriz as MoreIcon,
    CheckCircleOutline,
    HighlightOff
} from '@mui/icons-material';
import { toast } from 'react-toastify';

const CustomConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 18,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: '#e5e7eb',
        borderTopWidth: 1,
    },
}));

const StepIconRoot = styled('div')(({ ownerState }) => ({
    width: 36,
    height: 36,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #e5e7eb',
    backgroundColor: '#fff',
    color: '#6b7280',
    ...(ownerState.active && {
        borderColor: '#7c3aed',
        color: '#7c3aed',
    }),
}));

function CustomStepIcon(props) {
    const { active, className, icon } = props;
    return (
        <StepIconRoot ownerState={{ active }} className={className}>
            <Typography variant="body2" sx={{ fontWeight: '500' }}>{icon}</Typography>
        </StepIconRoot>
    );
}

class CommercialProfileSetup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedRole: '',
            selectedSegment: '',
            ddi: '55',
            whatsappNumber: '',
            // Novos estados para o domínio
            slug: '',
            domainLoading: false,
            domainAvailable: null, // null = sem busca, true = disponível, false = indisponível
            domainError: ''
        };
        this.debounceTimeout = null;
    }

    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    };

    // Altera o slug e dispara a verificação com debounce
    handleSlugChange = (event) => {
        // Remove caracteres especiais, espaços e força minúsculas para manter o padrão de subdomínio limpo
        const value = event.target.value
            .toLowerCase()
            .replace(/[^a-z0-9-_]/g, '');

        this.setState({
            slug: value,
            domainAvailable: null,
            domainError: ''
        }, () => {
            if (this.debounceTimeout) clearTimeout(this.debounceTimeout);

            if (this.state.slug.trim().length < 3) {
                if (this.state.slug.length > 0) {
                    this.setState({ domainError: 'O domínio deve ter pelo menos 3 caracteres.' });
                }
                return;
            }

            this.setState({ domainLoading: true });
            this.debounceTimeout = setTimeout(this.checkDomainAvailability, 500);
        });
    };

    // Integração com o seu backend Node.js
    checkDomainAvailability = async () => {
        const { slug } = this.state;
        try {
            // Substitua pela URL real da sua API Node.js
            const response = await fetch(`${process.env.REACT_APP_API_URL}/domains/check?slug=${slug}`);
            const data = await response.json();

            if (response.ok) {
                this.setState({
                    domainAvailable: true,
                    domainLoading: false
                });
            } else {
                this.setState({
                    domainError: 'Esse domínio já está em uso.',
                    domainLoading: false
                });
            }
        } catch (error) {
            this.setState({
                domainError: 'Erro de conexão com o servidor.',
                domainLoading: false
            });
        }
    };

    selectRole = (role) => {
        this.setState({ selectedRole: role });
    };

    selectSegment = (segmentKey) => {
        this.setState({ selectedSegment: segmentKey });
    };

    handleSubmit = () => {
        console.log("Dados enviados:", this.state);

        // Envia os dados para o backend
        fetch(`${process.env.REACT_APP_API_URL}/settings/commercial-profile`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(this.state),
        })
            .then(response => {
                if (response.ok) {
                    window.location.reload();
                } else {
                    toast.error('Erro ao atualizar o perfil comercial.');
                }
            })
            .catch(error => {
                console.error('Erro ao atualizar o perfil comercial:', error);
            });

    };

    render() {
        const { selectedRole, selectedSegment, ddi, whatsappNumber, slug, domainLoading, domainAvailable, domainError } = this.state;
        const steps = ['Seu papel', 'Categoria', 'WhatsApp (opcional)'];

        return (
            <Box sx={{ bgcolor: '#f4f5f7', minHeight: '100vh', display: 'flex', justifyContent: 'center', py: 6, px: 2, fontFamily: 'sans-serif' }}>
                <Card sx={{ maxWidth: 740, width: '100%', borderRadius: 4, boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.03)', p: { xs: 2, md: 4 }, border: '1px solid #eef0f3' }}>
                    <CardContent sx={{ p: 0 }}>

                        {/* Top Badge */}
                        <Box display="flex" justifyContent="center" mb={2}>
                            <Chip
                                label="CONFIGURAÇÃO INICIAL"
                                size="small"
                                sx={{ bgcolor: '#f5f3ff', color: '#7c3aed', fontWeight: 'bold', fontSize: '0.68rem', letterSpacing: '0.05em' }}
                            />
                        </Box>

                        {/* Cabeçalho */}
                        <Typography variant="h5" align="center" sx={{ fontWeight: 'bold', color: '#1a1a1a', mb: 1 }}>
                            Configure seu perfil comercial
                        </Typography>
                        <Typography variant="body2" align="center" color="textSecondary" sx={{ mb: 4, maxWidth: 500, mx: 'auto' }}>
                            Leva menos de dois minutos para personalizar o painel e começar a vender.
                        </Typography>

                        {/* Stepper Superior Horizontal */}
                        <Box sx={{ width: '100%', mb: 5 }}>
                            <Typography variant="caption" color="textSecondary" sx={{ ml: 4, mb: 1, display: 'block', fontWeight: 500 }}>
                                Etapa 1 de 3
                            </Typography>
                            <Stepper alternativeLabel activeStep={0} connector={<CustomConnector />}>
                                {steps.map((label, index) => (
                                    <Step key={label}>
                                        <StepLabel
                                            StepIconComponent={CustomStepIcon}
                                            componentsProps={{
                                                label: {
                                                    style: {
                                                        color: index === 0 ? '#7c3aed' : '#9ca3af',
                                                        fontWeight: index === 0 ? 'bold' : 'normal',
                                                        fontSize: '0.8rem',
                                                        marginTop: '8px'
                                                    }
                                                }
                                            }}
                                        >
                                            {label}
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </Box>

                        {/* ================= PASSO 1: SEU PAPEL ================= */}
                        <Card variant="outlined" sx={{ borderRadius: 3, p: 1, mb: 3, bgcolor: '#ffffff', borderColor: '#f0f0f0' }}>
                            <CardContent>
                                <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
                                    <Box>
                                        <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#6b7280', letterSpacing: '0.05em' }}>PASSO 1</Typography>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1a1a1a', mt: 0.5 }}>Qual é o seu papel no FazPedido?</Typography>
                                    </Box>
                                    <Chip label="Obrigatório" size="small" sx={{ bgcolor: '#f5f3ff', color: '#7c3aed', fontWeight: 500, fontSize: '0.72rem' }} />
                                </Box>
                                <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
                                    Escolha como pretende usar a plataforma. Você pode alterar depois em Configurações.
                                </Typography>

                                <Grid container spacing={2}>
                                    <Grid item size={{ xs: 12, md: 6 }}>
                                        <Box
                                            onClick={() => this.selectRole('lojista')}
                                            sx={{
                                                border: '1px solid',
                                                borderColor: selectedRole === 'lojista' ? '#7c3aed' : '#e5e7eb',
                                                borderRadius: 3, p: 2.5, cursor: 'pointer', height: '100%', transition: 'all 0.2s',
                                                '&:hover': { borderColor: '#7c3aed' },
                                                bgcolor: selectedRole === 'lojista' ? '#fbfaff' : '#fff'
                                            }}
                                        >
                                            <Box sx={{ bgcolor: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 2, width: 40, height: 40, p: 1, display: 'inline-flex', mb: 2, color: '#4b5563' }}>
                                                <StoreIcon />
                                            </Box>
                                            <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1, color: '#1a1a1a' }}>Sou lojista</Typography>
                                            <Typography variant="caption" color="textSecondary" sx={{ lineHeight: 1.5, display: 'block' }}>
                                                Quero organizar e divulgar meu catálogo online para meus clientes.
                                            </Typography>
                                        </Box>
                                    </Grid>

                                    <Grid item size={{ xs: 12, md: 6 }}>
                                        <Box
                                            onClick={() => this.selectRole('fornecedor')}
                                            sx={{
                                                border: '1px solid',
                                                borderColor: selectedRole === 'fornecedor' ? '#7c3aed' : '#e5e7eb',
                                                borderRadius: 3, p: 2.5, cursor: 'pointer', height: '100%', transition: 'all 0.2s',
                                                '&:hover': { borderColor: '#7c3aed' },
                                                bgcolor: selectedRole === 'fornecedor' ? '#fbfaff' : '#fff'
                                            }}
                                        >
                                            <Box sx={{ bgcolor: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 2, width: 40, height: 40, p: 1, display: 'inline-flex', mb: 2, color: '#4b5563' }}>
                                                <ShippingIcon />
                                            </Box>
                                            <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1, color: '#1a1a1a' }}>Sou fornecedor</Typography>
                                            <Typography variant="caption" color="textSecondary" sx={{ lineHeight: 1.5, display: 'block' }}>
                                                Quero disponibilizar meus produtos para lojistas e automatizar atualizações.
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>

                        {/* ================= NOVO PASSO: ENDEREÇO DO CATÁLOGO (DOMÍNIO) ================= */}
                        <Card variant="outlined" sx={{ borderRadius: 3, p: 1, mb: 3, bgcolor: '#ffffff', borderColor: '#f0f0f0' }}>
                            <CardContent>
                                <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
                                    <Box>
                                        <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#6b7280', letterSpacing: '0.05em' }}>ENDEREÇO DA LOJA</Typography>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1a1a1a', mt: 0.5 }}>Escolha o link exclusivo do seu catálogo</Typography>
                                    </Box>
                                    <Chip label="Obrigatório" size="small" sx={{ bgcolor: '#f5f3ff', color: '#7c3aed', fontWeight: 500, fontSize: '0.72rem' }} />
                                </Box>

                                <Box sx={{ mt: 2 }}>
                                    <TextField
                                        fullWidth
                                        name="slug"
                                        value={slug}
                                        onChange={this.handleSlugChange}
                                        placeholder="nomedasualoja"
                                        variant="outlined"
                                        size="small"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end" sx={{ '& p': { fontWeight: 'bold', color: '#1a1a1a' } }}>
                                                    .fazpedido.app
                                                </InputAdornment>
                                            ),
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: 2,
                                                bgcolor: '#fafafa',
                                                pr: 2
                                            }
                                        }}
                                    />

                                    {/* Feedbacks de validação em tempo real */}
                                    <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 0.5, minHeight: '20px' }}>
                                        {domainLoading && (
                                            <>
                                                <CircularProgress size={14} sx={{ color: '#7c3aed' }} />
                                                <Typography variant="caption" color="textSecondary">Verificando disponibilidade...</Typography>
                                            </>
                                        )}
                                        {domainAvailable === true && (
                                            <>
                                                <CheckCircleOutline sx={{ color: '#10b981', fontSize: 16 }} />
                                                <Typography variant="caption" sx={{ color: '#10b981', fontWeight: 500 }}>Este endereço está disponível!</Typography>
                                            </>
                                        )}
                                        {domainAvailable === false && (
                                            <>
                                                <HighlightOff sx={{ color: '#ef4444', fontSize: 16 }} />
                                                <Typography variant="caption" sx={{ color: '#ef4444', fontWeight: 500 }}>Este endereço já está em uso por outra loja.</Typography>
                                            </>
                                        )}
                                        {domainError && (
                                            <Typography variant="caption" sx={{ color: '#f59e0b', fontWeight: 500 }}>{domainError}</Typography>
                                        )}
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>

                        {/* ================= PASSO 2: SEGMENTO ================= */}
                        <Card variant="outlined" sx={{ borderRadius: 3, p: 1, mb: 3, bgcolor: '#ffffff', borderColor: '#f0f0f0' }}>
                            <CardContent>
                                <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
                                    <Box>
                                        <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#6b7280', letterSpacing: '0.05em' }}>PASSO 2</Typography>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1a1a1a', mt: 0.5 }}>Segmento principal da sua operação</Typography>
                                    </Box>
                                    <Chip label="Obrigatório" size="small" sx={{ bgcolor: '#f5f3ff', color: '#7c3aed', fontWeight: 500, fontSize: '0.72rem' }} />
                                </Box>
                                <Typography variant="body2" color="textSecondary" mb={3}>
                                    Selecione o segmento que melhor descreve sua loja. Usamos isso para organizar recomendações e métricas.
                                </Typography>

                                <Box display="flex" flexDirection="column" gap={1.5}>
                                    {[
                                        { key: '1', title: 'Moda', desc: 'Roupas, confecção e acessórios femininos ou masculinos.', },
                                        { key: '2', title: 'Alimentos e Bebidas', desc: 'Produtos alimentícios, bebidas e sucos.', },
                                        { key: '3', title: 'Eletrônicos', desc: 'Eletrodomesticos, celulares e tablets.', },
                                        { key: '4', title: 'Assistência Técnica', desc: 'Aparelhos e equipamentos para assistência técnica.', },
                                        { key: '5', title: 'Casa, Decoração e Construção', desc: 'Produtos para a casa, decoração e construção.', },
                                        { key: '6', title: 'Serviços e Instalações', desc: 'Serviços e equipamentos para instalações.', },
                                        { key: '7', title: 'Sob Encomenda', desc: 'Produtos que podem ser entregues em casa.', }
                                    ].map((segment) => (
                                        <Box
                                            key={segment.key}
                                            onClick={() => this.selectSegment(segment.key)}
                                            display="flex"
                                            alignItems="center"
                                            gap={2}
                                            sx={{
                                                border: '1px solid',
                                                borderColor: selectedSegment === segment.key ? '#7c3aed' : '#e5e7eb',
                                                borderRadius: 3, p: 2, cursor: 'pointer', transition: 'all 0.15s',
                                                '&:hover': { borderColor: '#7c3aed' },
                                                bgcolor: selectedSegment === segment.key ? '#fbfaff' : '#fff'
                                            }}
                                        >

                                            <Box>
                                                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#1a1a1a' }}>{segment.title}</Typography>
                                                <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 0.2 }}>{segment.desc}</Typography>
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                            </CardContent>
                        </Card>

                        {/* ================= PASSO OPCIONAL: WHATSAPP ================= */}
                        <Card variant="outlined" sx={{ borderRadius: 3, p: 1, mb: 4, bgcolor: '#ffffff', borderColor: '#f0f0f0' }}>
                            <CardContent>
                                <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
                                    <Box>
                                        <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#6b7280', letterSpacing: '0.05em' }}>PASSO OPCIONAL</Typography>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1a1a1a', mt: 0.5 }}>Centralize pedidos no WhatsApp</Typography>
                                    </Box>
                                    <Chip label="Opcional" size="small" sx={{ bgcolor: '#f3f4f6', color: '#4b5563', fontWeight: 500, fontSize: '0.72rem' }} />
                                </Box>
                                <Typography variant="body2" color="textSecondary" mb={3}>
                                    Informe o contato para exibir o botão no catálogo. Você pode configurar depois, se preferir.
                                </Typography>

                                <Grid container spacing={2} mb={2}>
                                    <Grid item xs={12}>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1, color: '#1a1a1a' }}>Número de WhatsApp (DDD + número)</Typography>
                                        <TextField
                                            fullWidth
                                            name="whatsappNumber"
                                            value={whatsappNumber}
                                            onChange={this.handleInputChange}
                                            variant="outlined"
                                            size="small"
                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: '#fafafa' } }}
                                        />
                                    </Grid>
                                </Grid>
                                <Typography variant="caption" color="textSecondary" sx={{ display: 'block', lineHeight: 1.4 }}>
                                    Usamos apenas números. Exemplo: 99 9 9999-9999. Se preferir, deixe em branco e configure depois.
                                </Typography>
                            </CardContent>
                        </Card>

                        {/* Botão de Conclusão */}
                        <Box>
                            <Button
                                fullWidth
                                variant="contained"
                                disabled={this.state.domainAvailable == null || this.state.selectedRole == '' || this.state.selectedSegment == ''}
                                onClick={this.handleSubmit}
                                sx={{
                                    bgcolor: '#7c3aed',

                                    textTransform: 'none',
                                    py: 1.5,
                                    borderRadius: 3,
                                    fontWeight: 'bold',
                                    fontSize: '1rem',
                                    boxShadow: 'none'
                                }}
                            >
                                Concluir e acessar painel
                            </Button>
                            <Typography variant="caption" align="center" color="textSecondary" sx={{ mt: 2, display: 'block' }}>
                                Você pode ajustar essas informações a qualquer momento em <span style={{ fontWeight: '500' }}>Mais → Configurações</span>.
                            </Typography>
                        </Box>

                    </CardContent>
                </Card>
            </Box>
        );
    }
}

export default CommercialProfileSetup;